import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = {
  // Subjects
  getSubjects: (headers) => axios.get(`${API}/subjects`, { headers }),
  createSubject: (data, headers) => axios.post(`${API}/subjects`, data, { headers }),
  updateSubject: (id, data, headers) => axios.put(`${API}/subjects/${id}`, data, { headers }),
  deleteSubject: (id, headers) => axios.delete(`${API}/subjects/${id}`, { headers }),

  // Topics
  getTopics: (subjectId, headers) => axios.get(`${API}/subjects/${subjectId}/topics`, { headers }),
  createTopic: (subjectId, data, headers) => axios.post(`${API}/subjects/${subjectId}/topics`, data, { headers }),
  updateTopic: (id, completed, headers) => axios.put(`${API}/topics/${id}`, { completed }, { headers }),

  // Homework
  getHomework: (headers) => axios.get(`${API}/homework`, { headers }),
  createHomework: (data, headers) => axios.post(`${API}/homework`, data, { headers }),
  updateHomework: (id, completed, headers) => axios.put(`${API}/homework/${id}`, { completed }, { headers }),
  deleteHomework: (id, headers) => axios.delete(`${API}/homework/${id}`, { headers }),

  // Exams
  getExams: (headers) => axios.get(`${API}/exams`, { headers }),
  createExam: (data, headers) => axios.post(`${API}/exams`, data, { headers }),
  updateExam: (id, preparationStatus, headers) => axios.put(`${API}/exams/${id}`, { preparation_status: preparationStatus }, { headers }),

  // Schedule
  getSchedule: (headers) => axios.get(`${API}/schedule`, { headers }),
  saveSchedule: (data, headers) => axios.post(`${API}/schedule/bulk`, data, { headers }),

  // Study Plan
  generateStudyPlan: (headers) => axios.post(`${API}/study-plan/generate`, {}, { headers }),
  getTodayStudyPlan: (headers) => axios.get(`${API}/study-plan/today`, { headers }),
  completeStudyTask: (planId, taskIndex, completed, headers) => axios.put(`${API}/study-plan/${planId}/task/${taskIndex}`, { completed }, { headers }),

  // Progress
  getProgressStats: (headers) => axios.get(`${API}/progress/stats`, { headers }),
};

export default api;
